import styled from "styled-components";
import {
  Button as AntButton,
  Form as AntForm,
  Input as AntInput,
} from 'antd';
import { AuthLogo, AuthBg } from "@assets/auth";

export const RootContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  gap: 16px;

  background-image: url(${AuthBg});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  align-items: center;

  .ant-btn-primary {
    width: 100%;
    height: 56px;
    color: #FFF;
    box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.10), 0px 7px 10px 0px rgba(255, 255, 255, 0.15) !important;
  }

  .ant-form-item-explain-error {
    color: #CCC !important;
  }

  position: relative;
`;

export const Heading = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: baseline;
  align-items: center;
`

export const NavContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  width: calc(100%);
  padding: 0 16px;
  flex-direction: row;
  justify-content: ${props => props.backKey ? 'end' : 'space-between'};
  align-items: center;
  height: 37px;/* need to add this to be the same height with nav from other auth pages */
  margin: 16px 0 0 0;
`;

export const ArrowIconWrapper = styled.div`
  padding: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 20px;
  background: rgba(0, 0, 0, 0.50);
  backdrop-filter: blur(25px);
  cursor: pointer;
`
export const BackButton = styled.div`
  padding: 8px 26px;
  color: #FFF;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;

  border-radius: 20px;
background: rgba(0, 0, 0, 0.50);

/* Background Blur */
backdrop-filter: blur(25px);
`;

export const SkipButton = styled(AntButton)`
  padding: 10px 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 16px;
  background: rgba(0, 0, 0, 0.50);
  backdrop-filter: blur(25px);
  border: none !important;

  color: #FFF;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  text-transform: uppercase;
  line-height: 1.5;
`

export const Logo = styled(AuthLogo)`
  margin: 16px auto 0 auto;
  width: 100%;
  height: auto;
`
export const Title = styled.div`
padding-bottom: 30px;
  color: #fff;
  text-align: center;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
`

export const ContentContainer = styled.div`
  width: calc(100% - 32px);
  margin: 0 auto 0;
  box-sizing: border-box;
`

export const Form = styled(AntForm)`
  margin: 24px 0 0 0;
  width: 100%;
  text-align: center;

  .ant-form-item-explain {
    text-align: left; /* align warning text to the left */
    margin-left: 8px;
  }

  .ant-form-item-label {
    margin: 0px 0 6px 8px;
    margin-left: 15px;
    text-align: left;
    padding: 0 !important;
  }

  .ant-form-item-label label {
    color: #fff;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 1.5;
    padding-bottom: 6px;
  }

`;
export const Input = styled(AntInput)`
  -moz-appearance: textfield;
;
  padding-left: 13px;
  height: 56px;
  background: #FFF !important;
  border-radius: 16px;
  border: 1px solid #CCC !important;

  color: #1E1E1E !important;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;

  &::placeholder {
    color: #979797 !important;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;

  }
  appearance: textfield;
  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    -webkit-appearance: none; /* WebKit */
    margin: 0;
  }
  ::-webkit-inner-spin-button:disabled,
  ::-webkit-outer-spin-button:disabled {
    display: none;
  }
`;

export const TextButton = styled(AntButton)`
  margin: -10px auto 0;

  width: 100%;
  justify-content: flex-end;
  color: #FECB01;
  text-align: right;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;

  &:hover{
    color: #FECB01 !important;
  }
`

export const Divider = styled.div`
width: 100px;
height: 1px;
background-color: #fff;
`;

export const ORText = styled.div`
  color: #FFF;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;

  padding: 2px 4px;
  min-width: 28px;
  min-height: 28px;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #FECB01;
  border-radius: 50%;
`

export const ORTextForRegister = styled(ORText)`
  margin: 0 !important;
  color: #FFF;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 171.429% */
`

export const LoginButton = styled(AntButton)`
  margin: 0px ;
  width: 100%;
  height: 55px !important;
`

export const RegisterButton = styled(AntButton)`
  margin: 0 0 20px;
  border-radius: 16px;
  height: 56px;
  width: calc(100% - 32px);
`

export const GoToPromoRegisterButton = styled(RegisterButton)`
  margin-top: 20px;
`

export const ContinueButton = styled(AntButton)`
`;

export const GoToLoginBtn = styled(AntButton)`
  width: calc(100% - 32px);
  height: 60px;
  margin-bottom: 30px;
`


export const TelegramLoginButton = styled.div`
margin: 0px;
width: calc(100% - 40px);
height: 52px;
border-radius: 15px;
display: flex;
gap: 10px;
align-items: center;
justify-content: center;
background-color: #fff;
border: 1px solid ${props => props.theme.primaryColor};
cursor: pointer;
position: relative;

font-size: 14px;
font-weight: bold;
color: ${props => props.theme.primaryColor};

svg {
  width: 24px;
}

.ant-spin {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
`;


export const SocialLoginWrapper = styled.div`
display:flex;
width:100%;
gap:20px;
align-items:center
`;

export const SpaceBetweenTopBottom = styled.div`
margin-top: 24px;
margin-bottom: 24px;
width:100%;
`;

export const SocialRegisterWrapper = styled.div`
display:flex;
width:100%;
gap:20px;
align-items:center
`;

export const TelegramRegisterButton = styled.div`
margin-top: 24px;
width: 100%;
height: 52px;
border-radius: 15px;
display: flex;
gap: 10px;
align-items: center;
justify-content: center;
background: #fff;
border: 1px solid ${props => props.theme.primaryColor};
cursor: pointer;
position: relative;

font-size: 14px;
font-weight: bold;
color: ${props => props.theme.primaryColor};

svg {
  width: 24px;
}

.ant-spin {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
`;